module.exports = __webpack_public_path__ + "img/progress_mobile@2x.f09b7419.png";